import { useQuery } from "@tanstack/react-query";
import api, { assetUrl } from "@/api";
import { DEFAULT_CONTENT, GALLERY, CAT_LABELS } from "@/data/content";

export function useSiteContent() {
  const { data } = useQuery({
    queryKey: ["site-content"],
    queryFn: async () => (await api.get("/content")).data,
    staleTime: 60_000,
  });
  const overrides = data || {};
  const content = { ...DEFAULT_CONTENT, ...overrides };
  const serviceImage = (id) => content[`service_image_${id}`] || DEFAULT_CONTENT[`service_image_${id}`];
  return { content, overrides, isLoading: data === undefined, serviceImage };
}

export function useSiteGallery() {
  const { data, isLoading } = useQuery({
    queryKey: ["gallery"],
    queryFn: async () => (await api.get("/gallery")).data,
    staleTime: 60_000,
  });
  const source = data && data.length ? data : GALLERY;
  const items = source.map((g) => ({
    id: g.id,
    title: g.title,
    cat: g.cat,
    catLabel: g.catLabel || CAT_LABELS[g.cat] || g.cat,
    image: assetUrl(g.image_url || g.image),
  }));
  return { items, isLoading, isFromDb: !!(data && data.length) };
}
